// Approximate rendered size of a platform IconButton (size="sm") plus the
// HStack spacing={2} gap between them, used to estimate whether the full
// row of platform icons fits in the space available on the toolbar.
const PLATFORM_ICON_WIDTH = 32;
const PLATFORM_ICON_GAP = 8;
export const STACK_PREVIEW_COUNT = 3;

// Rendered size of a single stacked icon (boxSize="8" = 2rem, matching the
// height of the size="sm" IconButtons used in the non-overflowing row) and
// the overlap between consecutive icons (HStack spacing="-5" = -1.25rem),
// used to guarantee the collapsed stack always has enough room to render
// fully (icons + the "+N" badge) instead of being clipped by the container.
const STACK_ICON_SIZE = 32;
const STACK_ICON_OVERLAP = 20;

// Horizontal padding either side of the stacked icons (paddingX={2} = 0.5rem),
// which is what makes the "a filter is selected" highlight visible around
// them rather than hidden behind the icons themselves.
const STACK_TRIGGER_PADDING_X = 8;

export const PLATFORM_STACK_MIN_WIDTH =
    STACK_ICON_SIZE +
    STACK_PREVIEW_COUNT * (STACK_ICON_SIZE - STACK_ICON_OVERLAP) +
    2 * STACK_TRIGGER_PADDING_X;

/** Width (px) needed to show every platform icon uncollapsed, given a count. */
export const getPlatformStackFullWidth = (count) =>
    count * PLATFORM_ICON_WIDTH + (count - 1) * PLATFORM_ICON_GAP;
